'use strict';

import moment from 'moment';
import { ELEMENT_STATE } from '@/constants/element/constants';
import store from '@/store';
export default class EcsElement {
  constructor(eventData) {
    if (eventData && eventData.interactionId && eventData.elementId) {
      Object.assign(this, EcsElement._extractElementDataFromEvent(eventData));
    }
  }

  get isClosed() {
    return this.elementStateId === ELEMENT_STATE.closed;
  }

  get isAbandoned() {
    return this.elementStateId === ELEMENT_STATE.abandoned;
  }

  get isActivating() {
    return this.elementStateId === ELEMENT_STATE.activating;
  }

  get isUnreachableDestination() {
    return this.elementStateId === ELEMENT_STATE.unreachableDestination;
  }

  get isEnded() {
    return this.isClosed || this.isAbandoned || this.isUnreachableDestination;
  }

  get isOnHold() {
    return [ELEMENT_STATE.diverted, ELEMENT_STATE.conferencedDiverted].includes(this.elementStateId);
  }

  get isConferenced() {
    return [ELEMENT_STATE.conferenced, ELEMENT_STATE.conferencedDiverted].includes(this.elementStateId);
  }

  get receptors() {
    let result = this.receptor ? [store.getters['CONTACTS/getContact'](this.receptor.id) || this.receptor] : [];

    if (this.isConferenced) {
      const interaction = store.getters['INTERACTIONS/getActiveInteraction'](this.interactionId);
      result = interaction.connectedPartiesListNew || interaction.connectedPartiesList || [];

      // NOTE: Patch for customer data :( Remove when ECS will fix state bug
      const customerIndex = result.findIndex(contact => contact.partyType === 'Customer' && !contact.id);
      if (customerIndex !== -1 && store.state.CONTACTS.ENTERPRISE.length > 0) {
        const connectedParty = result[customerIndex];
        /**
         * Workaround to solve https://jira.evolveip.net/browse/AWC-1727
         * once the connected parties list data comes with valid ids for HPBX users, this if conditions can be removed.
         */
        const enterpriseContact = store.getters['CONTACTS/getEnterpriseContactByContactUri'](connectedParty.contactUri);
        if (enterpriseContact) {
          const newConnectedParty = {
            id: enterpriseContact.id,
            name: enterpriseContact.name,
            partyType: 'Customer',
            contactUri: connectedParty.contactUri
          };
          result.splice(customerIndex, 1, newConnectedParty);
        }
      }
    }

    return result;
  }

  get answerTime() {
    const waitingTime = moment.duration(this.waitingTime);
    return moment.utc(this.entryTime).add(waitingTime.as('milliseconds'), 'milliseconds');
  }

  static _extractElementDataFromEvent(eventData) {
    const {
      elementId,
      interactionId,
      elementStateId,
      elementStateName,
      newElementStateId,
      newElementStateName,
      connectedPartiesList,
      connectedPartiesListNew,
      entryTime,
      waitingTime,
      totalWaitingDuration,
      timestamp,

      // EcsElement Extension
      receptor,
      recording,
      origin,
      answeredAt
    } = eventData;
    return {
      elementId,
      interactionId,
      elementStateId: elementStateId || newElementStateId,
      elementStateName: elementStateName || newElementStateName,
      connectedPartiesList,
      connectedPartiesListNew,
      entryTime,
      waitingTime,
      totalWaitingDuration,
      timestamp,
      receptor,
      recording,
      origin,
      answeredAt
    };
  }
}
